import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";
import "./CSS/animation.css";
import { Link } from "react-scroll";

function Header() {
  return (
    <div className="header container-fluid">
      <div className="row">
        <div className="col-md-4 logo">
          <a href="index.html">
            <img src="/img/logo1.svg" alt="" />
          </a>
        </div>
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <nav class="navbar navbar-expand-sm">
            <ul class="navbar-nav">
              <li class="nav-item">
                01.
                <Link
                  class="nav-link"
                  to="about"
                  spy={true}
                  smooth={true}
                  activeStyle={{ color: "red" }}
                >
                  About
                </Link>
              </li>
              <li class="nav-item">
                02.
                <Link class="nav-link" to="work" spy={true} smooth={true}>
                  Work
                </Link>
              </li>
              <li class="nav-item">
                03.
                <Link class="nav-link" to="ui" spy={true} smooth={true}>
                  Certifications
                </Link>
              </li>
              <li class="nav-item">
                04.
                <Link class="nav-link" to="contact" spy={true} smooth={true}>
                  Contact
                </Link>
              </li>
              <li class="nav-item">
                <a class="header__button" href="/Saud-khan-CV.pdf" open>
                  Resume
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Header;
